import { createTheme } from '@mui/material/styles';

const theme = createTheme({
	textField: {
		backgroundColor: 'lightgrey',
	},
	breakpoints: {
		values: { xs: 0, sm: 660, md: 960, smd: 1040, lg: 1280, xl: 1920 },
	},
	font: {
		default: 'Nunito, sans-serif',
	},
	palette: {
		primary: {
			light: '#43BBF7',
			main: '#00A0E8', //basic-button (blue)
			dark: '#222222', //dashboard (dark blue)
			blue: '#00A0E8',
			divider: '#E8ECEE', //border (light gray)
			dividerDark: '#BEBEBE',
			purple: '#796EFF',
			contrastText: '#ffffff',
			gray: '#F6F8F9',
			white: '#FFFFFF',
			black: '#000000',
			button: '#00A0E8',
		},
		secondary: {
			light: '#008CE3',
			main: '#42BEEE', // round-button (turquoise)
			gray: '#646f79',
			dark: '#646f79',
			font: '#6F7782',
			hover: '#008CE3',
		},
		background: {
			main: '#FFFFFF',
			gray: '#f6f8f9',
			active: '#C3E6FD',
			nav: '#222222',
			lifebookMenu: '#F7F7F7',
		},
		body: {
			primary: '#FFFFFF',
			secondary: '#F6F8F9',
			highlight: '#E8ECEE',
		},
		nav: {
			hover: 'rgba(255, 255, 255, 0.08)',
		},
		error: {
			main: '#FF5263',
			contrastText: '#FFFFFF',
		},
		button: {
			main: '#008CE3',
		},
		active: {
			main: '#42BEEE', //primary-active (yellow)
			dark: '#222B37',
		},
		disabled: {
			main: '#BABCBC', //light grey
			contrastText: '#000000',
		},
		font: {
			gray: '#A5A5A5',
			contrast: '#FFFFFF',
			default: '#00000',
		},
	},
	shape: {
		borderRadius: 4,
	},
	width: {
		contentMax: '722px',
		contentMin: '300px',
	},
	height: {
		LifebookNav: '60px',
	},
	transitions: {
		easing: {
			zoomAppear: {
				'0%': {
					transform: 'scale(0,0)',
				},
				'100%': {
					transform: 'scale(1,1)',
				},
			},
			zoomDisappear: {
				'0%': {
					transform: 'scale(1,1)',
				},
				'100%': {
					transform: 'scale(0,0)',
				},
			},
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					height: '32px',
					padding: '8px 16px',
					fontWeight: '700',
					fontSize: '12px',
					lineHeight: '12px',
				},
				contained: {
					boxShadow: 'none',
				},
			},
		},
		MuiDrawer: {
			styleOverrides: {
				paper: {
					minWidth: 256,
				},
				paperAnchorDockedLeft: {
					borderRight: 'none',
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderRadius: '12px',
				},
				input: {
					padding: '14px',
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				input: {
					height: '24px',
				},
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: {
					padding: '6px',
					fontSize: '12px',
					fontWeight: '500',
					color: '#6F7782',
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					borderRadius: '2px',
					fontSize: '12px',
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '0',
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				asterisk: {
					color: 'red',
				},
			},
		},
		MuiAutocomplete: {
			styleOverrides: {
				root: {
					width: '100%',
				},
				inputRoot: {
					height: '52px',
				},
			},
		},
		MuiSwitch: {
			styleOverrides: {
				switchBase: {
					color: '#00A0E8',
				},
				track: {
					'$checked$checked + &': {
						opacity: 0.35,
						backgroundColor: '#00A0E8',
					},
				},
				colorSecondary: {
					'&$checked': {
						color: '#00A0E8',
					},
				},
			},
		},
		MuiDatePicker: {
			styleOverrides: {
				color: 'red',
			},
		},
	},
});

export default theme;
